const ViewModeService = {
  setViewMode: (viewMode: string) => {
    sessionStorage.setItem("cex-viewMode", viewMode);
  },

  getViewMode: () => {
    return sessionStorage.getItem("cex-viewMode");
  },

  setDevice: (device: string) => {
    sessionStorage.setItem("cex-device", device);
  },

  getDevice: () => {
    return sessionStorage.getItem("cex-device");
  },
};

export default ViewModeService;
